import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    arrayAte,
    gerarArray,
    adicionaNaoInformar,
} from '../../../business-components/Array/Array'

import {
    mesMesAno,
    anoMesAno,
    formataMesAnoComBarra,
    formataMesAnoSemBarra,
    formataAnoMesSemBarra,
    calculaMeses,
    calculaMaiorMesAno,
} from '../../../business-components/Date/Date'

import {
    nvl,
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import {
    calculaParcelasTabelaSAC,
    dadosCompletosLinhaFinanciamento,
} from '../despesas-form/DespesasServiceFinanciamento'

import {
    graficoTransformaZeroNull,
    calculaIndexGraficoAnosIdades,
    calculaGraficoAcumulacaoMensal,
} from './EstudoServiceCalculo'

import {
    calculaTaxaRetornoLiquida,
    converteTaxaAnualEmMensal,
    calculaValorPresenteValorFuturo,
} from './EstudoServiceMatematicaFinanceira'

import {
    obtemLinhaTipoFinanciamentoDescricaoTipoFinanciamento,
    calculaValoresMesesFinanciamento,
} from './EstudoServiceDespesasFinanciamento'



export const processaValoresDefaultIniciaisComparacaoFinanciamentos = ( values ) => {
    
    // O valor default do campo objComparacaoFinanciamentos foi implementado em
    // ClienteService - inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient
}

export const financiamentoList = (values, idFinanciamento, descricaoSemValor) => {

    const financiamentoListAux = []

    values.financiamento?.forEach( (linhaFinanciamento, index) => {

        if (linhaFinanciamento.id !== idFinanciamento && dadosCompletosLinhaFinanciamento(linhaFinanciamento)) {

            const { descricaoTipoFinanciamento } =
                obtemLinhaTipoFinanciamentoDescricaoTipoFinanciamento(linhaFinanciamento)

            financiamentoListAux.push(
                {
                    id: linhaFinanciamento.id,
                    descricao: descricaoTipoFinanciamento +
                        (descricaoSemValor ? '' : LABEL.traco + formataValor(round(linhaFinanciamento.valorParcela, 2), 2))
                }
            )
        }
    })

    return adicionaNaoInformar(financiamentoListAux)
}



const analiseAluguelAposContemplacao = (values, linhaFinanciamentoSugerido) => {

    return linhaFinanciamentoSugerido.mesAnoInicialAluguelAposContemplacao &&
        linhaFinanciamentoSugerido.percAluguelMensalAposContemplacao &&
        linhaFinanciamentoSugerido.percReajusteAluguelAnualAposContemplacao &&
        linhaFinanciamentoSugerido.valorAluguelAposContemplacao &&
        !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
        !values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista
}



const calculaGraficoFinanciamento = (values, estudo, linhaFinanciamento, graficoFinanciamento, fluxoCaixaMensalFinanciamento) => {

    const { valorMensal, valorAmortizacao, mesInicial, anoInicial, mesFinal, anoFinal } =
        calculaValoresMesesFinanciamento(values, linhaFinanciamento, true)

    let maiorMes = mesFinal
    let maiorAno = anoFinal

    if (linhaFinanciamento.tabelaSAC) {

        // se essa chamada for alterada, revisar a chamada correspondente em calculaDespesasFinanciamento
        calculaGraficoAcumulacaoMensal(mesInicial, anoInicial, mesFinal, anoFinal, 0,
            valorAmortizacao, null, estudo.current.graficoAnos, graficoFinanciamento, null, values, estudo, 0, 0, false,
                linhaFinanciamento.qtdeParcelas, calculaParcelasTabelaSAC(values, linhaFinanciamento, false)/*linhaFinanciamento.taxaAnual*/,
                    null, null, fluxoCaixaMensalFinanciamento)

    } else {

        // se essa chamada for alterada, revisar a chamada correspondente em calculaDespesasFinanciamento
        calculaGraficoAcumulacaoMensal(mesInicial, anoInicial, mesFinal, anoFinal, 0,
            valorMensal, null, estudo.current.graficoAnos, graficoFinanciamento, null, values, estudo, 0, 0, false,
                null, linhaFinanciamento.taxaAnual, linhaFinanciamento.mesAnoPrimeiroReajuste, null, fluxoCaixaMensalFinanciamento)
    }

    if (linhaFinanciamento.possuiParcelasAdicionais && linhaFinanciamento.parcelasAdicionais) {
        
        linhaFinanciamento.parcelasAdicionais?.forEach( (item, ind) => {

            // se essa chamada for alterada, revisar a chamada correspondente em calculaDespesasFinanciamento
            calculaGraficoAcumulacaoMensal(mesMesAno(item.mesAnoInicial), anoMesAno(item.mesAnoInicial),
                mesMesAno(item.mesAnoFinal), anoMesAno(item.mesAnoFinal), 0,
                    round(item.valorParcela, 2), item.tipoPeriodicidadePagto, estudo.current.graficoAnos,
                        graficoFinanciamento, null, values, estudo, 0, 0, false, null, linhaFinanciamento.taxaAnual,
                            linhaFinanciamento.mesAnoPrimeiroReajuste, null, fluxoCaixaMensalFinanciamento)

            const { mes, ano } = calculaMaiorMesAno(maiorMes, maiorAno, mesMesAno(item.mesAnoFinal), anoMesAno(item.mesAnoFinal))

            maiorMes = mes
            maiorAno = ano
        })
    }

    if (analiseAluguelAposContemplacao(values, linhaFinanciamento) && linhaFinanciamento.percValorizacaoImovelAluguelAposContemplacao) {

        const maiorAnoAluguel = maiorAno + 11

        calculaGraficoAcumulacaoMensal(maiorMes, maiorAno, maiorMes, maiorAnoAluguel, 0,
            0, HARDCODE.idTipoPeriodicidadeMensal, estudo.current.graficoAnos,
                graficoFinanciamento, null, values, estudo, 0, 0, false, null, linhaFinanciamento.taxaAnual,
                    linhaFinanciamento.mesAnoPrimeiroReajuste, null, fluxoCaixaMensalFinanciamento)

        maiorMes = 12
        maiorAno = maiorAnoAluguel - 1
    }

    return { maiorMes: maiorMes, maiorAno: maiorAno}
}

const calculaTaxaRetornoLiquidaGraficoEconomia = (values, taxaAnual, tributacao) => {

    return calculaTaxaRetornoLiquida(taxaAnual, 0/*values.taxaInflacaoAnual ou values.taxaInflacaoAnualAposAposentadoria*/,
        tributacao ? values.tipoMomentoTributacaoIR : null, tributacao ? values.percIR : null,
            tributacao ? values.tempoMinimoEntreAportesResgatesCalculoIRAnos : null)
}

export const titleTaxaJurosAnual = (values, taxaAnual, tributacao) => {
    
    return ' (' + LABEL.taxa + ' ' + formataPerc(calculaTaxaRetornoLiquidaGraficoEconomia(values, taxaAnual, tributacao), 2) + ' ' +
        LABEL.taxaEfetivaAnual + ')'
}

export const titleTaxaJurosMensal = (taxaMensal) => {
    
    return ' (' + LABEL.taxa + ' ' + formataPerc(taxaMensal, 2) + ' ' + LABEL.taxaEfetivaMensal + ')'
}

export const titleTaxaReajusteAnual = (taxaAnual) => {
    
    return ' (' + LABEL.reajusteAbreviado + ' ' + formataPerc(taxaAnual, 2) + ' ' + LABEL.taxaEfetivaAnual + ')'
}

const calculaGraficoEconomia = (values, estudo, graficoEcomoniaPerdaFinanciamentoSugerido, mesInicial, anoInicial, mesFinal, anoFinal,
    valor, fluxoCaixaMensalEconomiaPerdaDetalhe, mesFinalTotal, anoFinalTotal, taxaAnualNULL, tributacao) => {

    const taxaJurosAnual =
        calculaTaxaRetornoLiquidaGraficoEconomia(values, taxaAnualNULL ? taxaAnualNULL : values.taxaJurosAnual, tributacao)

    const taxaJurosAnualAposAposentadoria =
        calculaTaxaRetornoLiquidaGraficoEconomia(values, taxaAnualNULL ? taxaAnualNULL : values.taxaJurosAnualAposAposentadoria,
            tributacao)

    // se essa chamada for alterada, revisar a chamada correspondente em calculaDespesasFinanciamento

    let saldo = calculaGraficoAcumulacaoMensal(mesInicial, anoInicial, mesFinal, anoFinal, 0,
        valor, null, estudo.current.graficoAnos,
            graficoEcomoniaPerdaFinanciamentoSugerido, null, values, estudo, taxaJurosAnual/*values.taxaRetornoAnualReal*/,
                taxaJurosAnualAposAposentadoria/*values.taxaRetornoAnualRealAposAposentadoria*/, true, null, null,
                    null, null/*estudo.current.evolucaoReservaFinanceiraEstudo*/, fluxoCaixaMensalEconomiaPerdaDetalhe)

    if (
            anoFinal < values.anoFinalVitalicioClienteConjuge ||
            (
                anoFinal === values.anoFinalVitalicioClienteConjuge &&
                mesFinal < 12
            )
    ) {

        if (mesFinal < 12) {

            const indexGraficoAnos =
                calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, anoFinal)

            graficoEcomoniaPerdaFinanciamentoSugerido[indexGraficoAnos] -= saldo
        }

        calculaGraficoAcumulacaoMensal(mesFinal === 12 ? 1 : mesFinal + 1,
            mesFinal === 12 ? anoFinal + 1 : anoFinal, mesFinalTotal,
                anoFinalTotal, saldo, 0, null, estudo.current.graficoAnos,
                    graficoEcomoniaPerdaFinanciamentoSugerido, null, values, estudo, taxaJurosAnual/*values.taxaRetornoAnualReal*/,
                        taxaJurosAnualAposAposentadoria/*values.taxaRetornoAnualRealAposAposentadoria*/,
                            true, null, null, null, null, fluxoCaixaMensalEconomiaPerdaDetalhe)
    }
}

export const calculaGraficoComparacaoFinanciamento = (values, estudo) => {

    if (
            values.objComparacaoFinanciamentos.idFinanciamentoSugerido &&
            //(
            //    values.objComparacaoFinanciamentos.idFinanciamentoAlternativo ||
            //    values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista
            //) &&
            (
                !values.objComparacaoFinanciamentos.mesAnoPagoMesmoTempo ||
                values.objComparacaoFinanciamentos.mesAnoPagoMesmoTempo.length === 6
            )
    ) {

        let indexGraficoAnos = calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, values.anoFinalVitalicioClienteConjuge)

        let graficoFinanciamentoSugerido = gerarArray(0, indexGraficoAnos + 1)
        let graficoFinanciamentoAlternativo = [...graficoFinanciamentoSugerido]
        let graficoFinanciamentoSugeridoValorAluguelAposContemplacao = [...graficoFinanciamentoSugerido]
        let graficoFinanciamentoSugeridoValorImovelAposContemplacao = [...graficoFinanciamentoSugerido]
        let descricaoFinanciamentoSugeridoValorAluguelAposContemplacao = ''
        let descricaoSaldoInvestimentoAluguelAposContemplacao = ''
        let descricaoSaldoVendaAposQuitacao = ''
        let descricaoSaldoAluguelAposQuitacao = ''
        let descricaoFinanciamentoSugeridoValorizacaoImovelAluguelAposContemplacao = ''
        let graficoEcomoniaPerdaFinanciamentoSugerido = [...graficoFinanciamentoSugerido]
        const graficoEcomoniaFinanciamentoSugerido = []
        const graficoPerdaFinanciamentoSugerido = []
        let graficoSaldoPagtoFinanciamentoSugeridoReserva = [...graficoFinanciamentoSugerido]
        let graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal = [...graficoFinanciamentoSugerido]
        const graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo = []
        const graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo = []
        const graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo = []
        const graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo = []
        let graficoSaldoInvestimentoSaldoAluguelAposContemplacao = [...graficoFinanciamentoSugerido]
        let graficoSaldoInvestimentoSaldoVendaAposQuitacao = [...graficoFinanciamentoSugerido]
        let graficoSaldoInvestimentoSaldoAluguelAposQuitacao = [...graficoFinanciamentoSugerido]
        let fluxoCaixaMensalFinanciamentoSugerido = []
        let fluxoCaixaMensalFinanciamentoAlternativo = []
        let fluxoCaixaMensalFinanciamentoSugeridoValorAluguelAposContemplacao = []
        let fluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao = []
        let fluxoCaixaMensalEconomiaPerdaDetalhe = []
        let fluxoCaixaMensalSaldoPagtoFinanciamentoSugeridoReserva = []
        let valorPagtoFinanciamentoAVista
        let fluxoCaixaMensalSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal = []
        let fluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposContemplacao = []
        let fluxoCaixaMensalSaldoInvestimentoSaldoVendaAposQuitacao = []
        let fluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposQuitacao = []
        //let idadesFinanciamento
        let anosFinanciamento

        const linhaFinanciamentoSugerido =
            pesquisaList(values.financiamento, values.objComparacaoFinanciamentos.idFinanciamentoSugerido)

        const linhaFinanciamentoAlternativo =
            pesquisaList(values.financiamento, values.objComparacaoFinanciamentos.idFinanciamentoAlternativo)

        if (
                linhaFinanciamentoSugerido.id &&
                (
                    !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo ||
                    (
                        values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                        linhaFinanciamentoAlternativo.id
                    )
                )
        ) {

            const maiorMesAnoFinanciamentoSugerido = calculaGraficoFinanciamento(values, estudo,
                linhaFinanciamentoSugerido, graficoFinanciamentoSugerido, fluxoCaixaMensalFinanciamentoSugerido)

            const maiorMesAnoFinanciamentoAlternativo = calculaGraficoFinanciamento(values, estudo,
                linhaFinanciamentoAlternativo, graficoFinanciamentoAlternativo, fluxoCaixaMensalFinanciamentoAlternativo)

            if (analiseAluguelAposContemplacao(values, linhaFinanciamentoSugerido)) {

                const mesMesAnoInicialAluguelAposContemplacao =
                    mesMesAno(linhaFinanciamentoSugerido.mesAnoInicialAluguelAposContemplacao)
                const anoMesAnoInicialAluguelAposContemplacao =
                    anoMesAno(linhaFinanciamentoSugerido.mesAnoInicialAluguelAposContemplacao)

                calculaGraficoAcumulacaoMensal(mesMesAnoInicialAluguelAposContemplacao,
                    anoMesAnoInicialAluguelAposContemplacao,
                        maiorMesAnoFinanciamentoSugerido.maiorMes,
                            maiorMesAnoFinanciamentoSugerido.maiorAno, 0,
                                round(linhaFinanciamentoSugerido.valorAluguelAposContemplacao, 2), null,
                                    estudo.current.graficoAnos, graficoFinanciamentoSugeridoValorAluguelAposContemplacao, null,
                                        values, estudo, 0, 0, false, null,
                                            linhaFinanciamentoSugerido.percReajusteAluguelAnualAposContemplacao/*values.taxaInflacaoAnual linhaFinanciamentoSugerido.taxaAnual*/,
                                                formataMesAnoSemBarra(mesMesAnoInicialAluguelAposContemplacao,
                                                    anoMesAnoInicialAluguelAposContemplacao + 1), null,
                                                        fluxoCaixaMensalFinanciamentoSugeridoValorAluguelAposContemplacao)
                
                descricaoFinanciamentoSugeridoValorAluguelAposContemplacao = LABEL.valorAluguelAposContemplacao + '<br/>' +
                    titleTaxaJurosMensal(linhaFinanciamentoSugerido.percAluguelMensalAposContemplacao) + '<br/>' + 
                        titleTaxaReajusteAnual(linhaFinanciamentoSugerido.percReajusteAluguelAnualAposContemplacao/*values.taxaInflacaoAnual*/) 

                descricaoSaldoInvestimentoAluguelAposContemplacao = LABEL.saldoInvestimentoAluguelAposContemplacao +
                    titleTaxaJurosAnual(values, values.taxaJurosAnual, true)
            }

            const { ano, mes } = calculaMaiorMesAno(maiorMesAnoFinanciamentoSugerido.maiorMes,
                maiorMesAnoFinanciamentoSugerido.maiorAno, maiorMesAnoFinanciamentoAlternativo.maiorMes,
                maiorMesAnoFinanciamentoAlternativo.maiorAno)

            const mesFinal =
                values.objComparacaoFinanciamentos.idFinanciamentoAlternativo ? mes : maiorMesAnoFinanciamentoSugerido.maiorMes
            const anoFinal =
                values.objComparacaoFinanciamentos.idFinanciamentoAlternativo ? ano : maiorMesAnoFinanciamentoSugerido.maiorAno

            if (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista) {

                valorPagtoFinanciamentoAVista =
                    round(values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista, 2)

                if (
                        values.objComparacaoFinanciamentos.mesAnoPagtoFinanciamentoAVista &&
                        values.objComparacaoFinanciamentos.mesAnoPagtoFinanciamentoAVista.length === 6
                ) {

                    const taxaJurosAnual = calculaTaxaRetornoLiquidaGraficoEconomia(values, values.taxaJurosAnual, true)

                    const taxaJurosMensal = converteTaxaAnualEmMensal(taxaJurosAnual)

                    const qtdeMeses = calculaMeses(estudo.current.mesAnoAtual,
                        values.objComparacaoFinanciamentos.mesAnoPagtoFinanciamentoAVista)

                    valorPagtoFinanciamentoAVista =
                        calculaValorPresenteValorFuturo(valorPagtoFinanciamentoAVista, taxaJurosMensal, qtdeMeses) 
                }

                calculaGraficoEconomia(values, estudo, graficoSaldoPagtoFinanciamentoSugeridoReserva, estudo.current.mesAtual,
                    estudo.current.anoAtual, estudo.current.mesAtual, estudo.current.anoAtual, valorPagtoFinanciamentoAVista,
                        fluxoCaixaMensalSaldoPagtoFinanciamentoSugeridoReserva, mesFinal, anoFinal, null, true)

                if (
                        !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                        values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal
                ) {

                    calculaGraficoEconomia(values, estudo, graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal,
                        estudo.current.mesAtual, estudo.current.anoAtual, estudo.current.mesAtual, estudo.current.anoAtual,
                            round(values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal, 2),
                                fluxoCaixaMensalSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal, mesFinal, anoFinal, null, true)
                }
            }

            if (analiseAluguelAposContemplacao(values, linhaFinanciamentoSugerido)) {

                const mesMesAnoInicialAluguelAposContemplacao =
                    mesMesAno(linhaFinanciamentoSugerido.mesAnoInicialAluguelAposContemplacao)
                const anoMesAnoInicialAluguelAposContemplacao =
                    anoMesAno(linhaFinanciamentoSugerido.mesAnoInicialAluguelAposContemplacao)

                ////calculaGraficoEconomia(values, estudo, graficoFinanciamentoSugeridoValorImovelAposContemplacao,
                ////    mesMesAnoInicialAluguelAposContemplacao, anoMesAnoInicialAluguelAposContemplacao,
                ////        mesMesAnoInicialAluguelAposContemplacao, anoMesAnoInicialAluguelAposContemplacao,
                ////            round(linhaFinanciamentoSugerido.valorCreditoConsorcioContemplacao, 2),
                ////                fluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao, mesFinal, anoFinal,
                ////                    linhaFinanciamentoSugerido.percValorizacaoImovelAluguelAposContemplacao, false)

                calculaGraficoAcumulacaoMensal(mesMesAnoInicialAluguelAposContemplacao,
                    anoMesAnoInicialAluguelAposContemplacao,
                        maiorMesAnoFinanciamentoSugerido.maiorMes,
                            maiorMesAnoFinanciamentoSugerido.maiorAno, 0,
                                round(linhaFinanciamentoSugerido.valorCreditoConsorcioContemplacao, 2), null,
                                    estudo.current.graficoAnos, graficoFinanciamentoSugeridoValorImovelAposContemplacao, null,
                                        values, estudo, 0, 0, false, null,
                                            linhaFinanciamentoSugerido.percValorizacaoImovelAluguelAposContemplacao,////values.taxaInflacaoAnual/*linhaFinanciamentoSugerido.taxaAnual*/,
                                                formataMesAnoSemBarra(mesMesAnoInicialAluguelAposContemplacao,
                                                    anoMesAnoInicialAluguelAposContemplacao + 1), null,
                                                        fluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao)

                //const { mesInicial, anoInicial } =
                //    calculaValoresMesesFinanciamento(values, linhaFinanciamentoSugerido, true)

                //calculaGraficoAcumulacaoMensal(mesInicial, anoInicial, mesFinal, anoFinal, 0,
                //    round(linhaFinanciamentoSugerido.valorCreditoConsorcioContemplacao, 2), null,
                //        estudo.current.graficoAnos, graficoFinanciamentoSugeridoValorImovelAposContemplacao, null,
                //            values, estudo, 0, 0, false, null,
                //                linhaFinanciamentoSugerido.percValorizacaoImovelAluguelAposContemplacao/*linhaFinanciamentoSugerido.taxaAnual*/,
                //                    linhaFinanciamentoSugerido.mesAnoPrimeiroReajuste, null,
                //                        fluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao)

                descricaoFinanciamentoSugeridoValorizacaoImovelAluguelAposContemplacao =
                    LABEL.valorizacaoImovelAluguelAposContemplacao +
                        titleTaxaJurosAnual(values, linhaFinanciamentoSugerido.percValorizacaoImovelAluguelAposContemplacao, false)
            }

            estudo.current.graficoAnos?.forEach( (linha, ind) => {

                if (linha <= anoFinal) {

                    let mes = 1

                    if (linha === estudo.current.anoAtual) {

                        mes = estudo.current.mesAtual
                    }

                    while (mes <= 12) {

                        const mesAno = formataMesAnoComBarra(mes, linha)
                        const valorFinanciamentoSugerido = nvl(pesquisaList(fluxoCaixaMensalFinanciamentoSugerido, mesAno).valor, 0)
                        const valorFinanciamentoAlternativo = nvl(pesquisaList(fluxoCaixaMensalFinanciamentoAlternativo, mesAno).valor, 0)

                        if (valorFinanciamentoSugerido !== 0 || valorFinanciamentoAlternativo !== 0) {

                            let saldo
                            
                            if (
                                    values.objComparacaoFinanciamentos.mesAnoPagoMesmoTempo &&
                                    formataAnoMesSemBarra(mes, linha) <=
                                        formataAnoMesSemBarra(mesMesAno(values.objComparacaoFinanciamentos.mesAnoPagoMesmoTempo),
                                            anoMesAno(values.objComparacaoFinanciamentos.mesAnoPagoMesmoTempo))
                            ) {

                                saldo = valorFinanciamentoSugerido * -1

                            } else {

                                if (valorFinanciamentoSugerido === 0) {

                                    saldo = valorFinanciamentoAlternativo

                                } else {

                                    if (valorFinanciamentoAlternativo === 0) {

                                        saldo = valorFinanciamentoSugerido * -1

                                    } else {

                                        saldo = valorFinanciamentoAlternativo - valorFinanciamentoSugerido
                                    }
                                }
                            }

                            calculaGraficoEconomia(values, estudo, graficoEcomoniaPerdaFinanciamentoSugerido, mes,
                                linha, mes, linha, saldo, fluxoCaixaMensalEconomiaPerdaDetalhe, mesFinal, anoFinal, null, true)

                            if (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista) {

                                calculaGraficoEconomia(values, estudo, graficoSaldoPagtoFinanciamentoSugeridoReserva, mes,
                                    linha, mes, linha, valorFinanciamentoSugerido * -1,
                                        fluxoCaixaMensalSaldoPagtoFinanciamentoSugeridoReserva,
                                            mesFinal, anoFinal, null, true)
                            }
                        }

                        mes++
                    }
                }
            })

            indexGraficoAnos = calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, anoFinal)
            
            graficoFinanciamentoSugerido = arrayAte(graficoFinanciamentoSugerido, indexGraficoAnos)
            graficoFinanciamentoAlternativo = arrayAte(graficoFinanciamentoAlternativo, indexGraficoAnos)
            graficoFinanciamentoSugeridoValorAluguelAposContemplacao =
                arrayAte(graficoFinanciamentoSugeridoValorAluguelAposContemplacao, indexGraficoAnos)
            graficoFinanciamentoSugeridoValorImovelAposContemplacao =
                arrayAte(graficoFinanciamentoSugeridoValorImovelAposContemplacao, indexGraficoAnos)
            graficoEcomoniaPerdaFinanciamentoSugerido = arrayAte(graficoEcomoniaPerdaFinanciamentoSugerido, indexGraficoAnos)
            graficoSaldoPagtoFinanciamentoSugeridoReserva = arrayAte(graficoSaldoPagtoFinanciamentoSugeridoReserva, indexGraficoAnos)
            //idadesFinanciamento = arrayAte(estudo.current.graficoIdades, indexGraficoAnos)
            anosFinanciamento = arrayAte(estudo.current.graficoAnos, indexGraficoAnos)

            graficoEcomoniaPerdaFinanciamentoSugerido?.forEach( (linha, ind) => {

                if (linha >= 0) {

                    graficoEcomoniaFinanciamentoSugerido.push(linha)
                    graficoPerdaFinanciamentoSugerido.push(null)

                    //if (ind === 1 && graficoEcomoniaPerdaFinanciamentoSugerido[ind - 1] < 0) {

                    //    graficoPerdaFinanciamentoSugerido[ind] = graficoEcomoniaFinanciamentoSugerido[ind]
                        
                    //} else {

                    //    if (ind > 0 && graficoEcomoniaPerdaFinanciamentoSugerido[ind - 1] < 0) {

                    //        graficoEcomoniaFinanciamentoSugerido[ind - 1] = graficoPerdaFinanciamentoSugerido[ind - 1]
                    //    }
                    //}

                } else {

                    graficoEcomoniaFinanciamentoSugerido.push(null)
                    graficoPerdaFinanciamentoSugerido.push(linha)

                    //if (ind > 0 && graficoEcomoniaPerdaFinanciamentoSugerido[ind - 1] >= 0) {

                    //    graficoPerdaFinanciamentoSugerido[ind - 1] = graficoEcomoniaFinanciamentoSugerido[ind - 1]
                    //}
                }



                if (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista) {

                    if (graficoSaldoPagtoFinanciamentoSugeridoReserva[ind] >= 0) {

                        graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo.push(graficoSaldoPagtoFinanciamentoSugeridoReserva[ind])
                        graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo.push(null)

                        if (ind > 0 && graficoSaldoPagtoFinanciamentoSugeridoReserva[ind - 1] < 0) {

                            graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo[ind - 1] = graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo[ind - 1]
                        }

                    } else {

                        graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo.push(null)
                        graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo.push(graficoSaldoPagtoFinanciamentoSugeridoReserva[ind])

                        if (ind > 0 && graficoSaldoPagtoFinanciamentoSugeridoReserva[ind - 1] >= 0) {

                            graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo[ind - 1] = graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo[ind - 1]
                        }
                    }

                    if (
                            !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                            values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal
                    ) {

                        if (graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal[ind] >= 0) {

                            graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo.push(
                                graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal[ind])
                            graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo.push(null)
    
                            if (ind > 0 && graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal[ind - 1] < 0) {
    
                                graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo[ind - 1] =
                                    graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo[ind - 1]
                            }
    
                        } else {
    
                            graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo.push(null)
                            graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo.push(
                                graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal[ind])
    
                            if (ind > 0 && graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal[ind - 1] >= 0) {
    
                                graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo[ind - 1] =
                                    graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo[ind - 1]
                            }
                        }
                    }
                }
            })

            let indFluxoMensal = 0

            fluxoCaixaMensalEconomiaPerdaDetalhe?.forEach( (linha, ind) => {

                const linhaFluxoCaixaMensalFinanciamentoSugerido =
                    pesquisaList(fluxoCaixaMensalFinanciamentoSugerido, linha.id)

                if (linhaFluxoCaixaMensalFinanciamentoSugerido.id) {

                    fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugerido =
                        linhaFluxoCaixaMensalFinanciamentoSugerido.valor

                    if (descricaoFinanciamentoSugeridoValorAluguelAposContemplacao) {

                        const linhaFluxoCaixaMensalFinanciamentoSugeridoValorAluguelAposContemplacao =
                            pesquisaList(fluxoCaixaMensalFinanciamentoSugeridoValorAluguelAposContemplacao, linha.id)

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoValorAluguelAposContemplacao =
                            linhaFluxoCaixaMensalFinanciamentoSugeridoValorAluguelAposContemplacao.valor

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoAluguelAposContemplacao =
                            nvl(linhaFluxoCaixaMensalFinanciamentoSugeridoValorAluguelAposContemplacao.valor, 0) -
                                linhaFluxoCaixaMensalFinanciamentoSugerido.valor

                        const mesSaldoAluguelAposContemplacao = mesMesAno(linha.id.replace('/', ''))
                        const anoSaldoAluguelAposContemplacao = anoMesAno(linha.id.replace('/', ''))

                        //
                        const taxaJurosAnual = calculaTaxaRetornoLiquidaGraficoEconomia(values, values.taxaJurosAnual, true)

                        const taxaJurosMensal = converteTaxaAnualEmMensal(taxaJurosAnual)

                        const saldoAluguelAposContemplacao  =
                            fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoAluguelAposContemplacao > 0
                                ?
                                    fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoAluguelAposContemplacao /
                                        (1 + (taxaJurosMensal / 100))
                                :
                                    fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoAluguelAposContemplacao
                        //

                        calculaGraficoEconomia(values, estudo, graficoSaldoInvestimentoSaldoAluguelAposContemplacao,
                            mesSaldoAluguelAposContemplacao, anoSaldoAluguelAposContemplacao, mesSaldoAluguelAposContemplacao,
                                anoSaldoAluguelAposContemplacao,
                                    saldoAluguelAposContemplacao/*fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoAluguelAposContemplacao*/,
                                        fluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposContemplacao,
                                            mesFinal, anoFinal, null, true)

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao =
                            fluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposContemplacao[ind].saldo
                            
                        const linhaFluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao =
                            pesquisaList(fluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao, linha.id)

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoValorImovelAposContemplacao =
                            linhaFluxoCaixaMensalFinanciamentoSugeridoValorImovelAposContemplacao.valor//saldo

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoResultadoAluguelAposContemplacao =
                            fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao +
                                fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoValorImovelAposContemplacao
                    }

                    indFluxoMensal = ind
                }

                const linhaFluxoCaixaMensalFinanciamentoAlternativo =
                    pesquisaList(fluxoCaixaMensalFinanciamentoAlternativo, linha.id)

                if (linhaFluxoCaixaMensalFinanciamentoAlternativo.id) {

                    fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoAlternativo =
                        linhaFluxoCaixaMensalFinanciamentoAlternativo.valor

                    indFluxoMensal = ind
                }

                if (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista) {

                    const linhaFluxoCaixaMensalSaldoPagtoFinanciamentoSugeridoReserva =
                        pesquisaList(fluxoCaixaMensalSaldoPagtoFinanciamentoSugeridoReserva, linha.id)

                    fluxoCaixaMensalEconomiaPerdaDetalhe[ind].saldoPagtoFinanciamentoSugeridoAVista =
                        linhaFluxoCaixaMensalSaldoPagtoFinanciamentoSugeridoReserva.saldo

                    if (
                            !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                            values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal
                    ) {

                        const linhaFluxoCaixaMensalSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal =
                            pesquisaList(fluxoCaixaMensalSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal, linha.id)

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal =
                            linhaFluxoCaixaMensalSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensal.saldo
                    }
                }
            })

            if (
                    descricaoFinanciamentoSugeridoValorAluguelAposContemplacao &&
                    linhaFinanciamentoSugerido.mesAnoVendaAposQuitacao
            ) {

                const mesMesAnoVendaAposQuitacao = mesMesAno(linhaFinanciamentoSugerido.mesAnoVendaAposQuitacao)
                const anoMesAnoVendaAposQuitacao = anoMesAno(linhaFinanciamentoSugerido.mesAnoVendaAposQuitacao)

                const linhaFluxoCaixaMensalEconomiaPerdaDetalhe = pesquisaList(fluxoCaixaMensalEconomiaPerdaDetalhe,
                    formataMesAnoComBarra(mesMesAnoVendaAposQuitacao, anoMesAnoVendaAposQuitacao))

                const taxaJurosAnual = calculaTaxaRetornoLiquidaGraficoEconomia(values, values.taxaJurosAnual, true)

                const taxaJurosMensal = converteTaxaAnualEmMensal(taxaJurosAnual)

                const valorImovelAposContemplacaoInicial  =
                    linhaFluxoCaixaMensalEconomiaPerdaDetalhe.financiamentoSugeridoValorImovelAposContemplacao /
                    (1 + (taxaJurosMensal / 100))

                calculaGraficoAcumulacaoMensal(mesMesAnoVendaAposQuitacao,
                    anoMesAnoVendaAposQuitacao,
                        maiorMesAnoFinanciamentoSugerido.maiorMes,
                            maiorMesAnoFinanciamentoSugerido.maiorAno, valorImovelAposContemplacaoInicial,
                                0, null, estudo.current.graficoAnos, graficoSaldoInvestimentoSaldoVendaAposQuitacao,
                                    null, values, estudo, taxaJurosAnual, taxaJurosAnual, true, null,
                                        null, null, null, fluxoCaixaMensalSaldoInvestimentoSaldoVendaAposQuitacao)
                                        
                fluxoCaixaMensalEconomiaPerdaDetalhe?.forEach( (linha, ind) => {

                    const linhaFluxoCaixaMensalSaldoInvestimentoSaldoVendaAposQuitacao =
                        pesquisaList(fluxoCaixaMensalSaldoInvestimentoSaldoVendaAposQuitacao, linha.id)

                    if (linhaFluxoCaixaMensalSaldoInvestimentoSaldoVendaAposQuitacao.id) {
                        
                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoVendaAposQuitacao =
                            linhaFluxoCaixaMensalSaldoInvestimentoSaldoVendaAposQuitacao.saldo

                        const mesSaldoAluguelAposQuitacao = mesMesAno(linha.id.replace('/', ''))
                        const anoSaldoAluguelAposQuitacao = anoMesAno(linha.id.replace('/', ''))

                        const saldoAluguelAposContemplacao  =
                            fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoSaldoAluguelAposContemplacao /
                                (1 + (taxaJurosMensal / 100))

                        calculaGraficoEconomia(values, estudo, graficoSaldoInvestimentoSaldoAluguelAposQuitacao,
                            mesSaldoAluguelAposQuitacao, anoSaldoAluguelAposQuitacao, mesSaldoAluguelAposQuitacao,
                                anoSaldoAluguelAposQuitacao,
                                    saldoAluguelAposContemplacao,
                                        fluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposQuitacao,
                                            mesFinal, anoFinal, null, true)

                        const linhaFluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposQuitacao =
                            pesquisaList(fluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposQuitacao, linha.id)

                        fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoResultadoAluguelAposQuitacao =
                            linhaFluxoCaixaMensalSaldoInvestimentoSaldoAluguelAposQuitacao.saldo +
                                fluxoCaixaMensalEconomiaPerdaDetalhe[ind].financiamentoSugeridoValorImovelAposContemplacao
                    }
                })

                descricaoSaldoVendaAposQuitacao = LABEL.vendaAposQuitacao + '<br/>' +
                    titleTaxaJurosAnual(values, values.taxaJurosAnual, true)

                descricaoSaldoAluguelAposQuitacao = LABEL.aluguelAposQuitacao// + '<br/>' +
                    //titleTaxaJurosAnual(values, values.taxaJurosAnual, true)
            }
            
            fluxoCaixaMensalEconomiaPerdaDetalhe = arrayAte(fluxoCaixaMensalEconomiaPerdaDetalhe, indFluxoMensal)

            let fluxoCaixaMensalEconomiaPerdaResumo = []

            let parcelas = 0
            let id = ''
            let financiamentoSugeridoTotal = 0
            let financiamentoAlternativoTotal = 0
            let financiamentoSugeridoValorAluguelAposContemplacaoTotal = 0
            let financiamentoSugeridoSaldoAluguelAposContemplacaoTotal = 0
            let valorTotal = 0

            let financiamentoSugeridoTotalGeral = 0
            let financiamentoAlternativoTotalGeral = 0
            let financiamentoSugeridoValorAluguelAposContemplacaoTotalGeral = 0
            let financiamentoSugeridoSaldoAluguelAposContemplacaoTotalGeral = 0
            let valorTotalGeral = 0

            fluxoCaixaMensalEconomiaPerdaDetalhe?.forEach( (linha, ind) => {

                parcelas++

                if (!id) {
                    
                    id = linha.id
                }

                financiamentoSugeridoTotal += nvl(linha.financiamentoSugerido, 0)
                financiamentoAlternativoTotal += nvl(linha.financiamentoAlternativo, 0)
                financiamentoSugeridoValorAluguelAposContemplacaoTotal += nvl(linha.financiamentoSugeridoValorAluguelAposContemplacao, 0)
                financiamentoSugeridoSaldoAluguelAposContemplacaoTotal +=
                    nvl(linha.financiamentoSugeridoSaldoAluguelAposContemplacao, 0)
                valorTotal += linha.valor

                if ((ind + 1) % 12 === 0 || ind === fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1) {
                    
                    fluxoCaixaMensalEconomiaPerdaResumo.push({
                        parcelas: parcelas,
                        id: id + ' - ' + linha.id,
                        financiamentoSugerido: financiamentoSugeridoTotal,
                        financiamentoAlternativo: financiamentoAlternativoTotal,
                        financiamentoSugeridoValorAluguelAposContemplacao: financiamentoSugeridoValorAluguelAposContemplacaoTotal,
                        financiamentoSugeridoSaldoAluguelAposContemplacao:
                            financiamentoSugeridoSaldoAluguelAposContemplacaoTotal,
                        financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao:
                            linha.financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao,
                        financiamentoSugeridoValorImovelAposContemplacao:
                            linha.financiamentoSugeridoValorImovelAposContemplacao,
                        financiamentoSugeridoResultadoAluguelAposContemplacao:
                            linha.financiamentoSugeridoResultadoAluguelAposContemplacao,
                        financiamentoSugeridoSaldoVendaAposQuitacao:
                            linha.financiamentoSugeridoSaldoVendaAposQuitacao,
                        financiamentoSugeridoResultadoAluguelAposQuitacao:
                            linha.financiamentoSugeridoResultadoAluguelAposQuitacao,
                        valor: valorTotal,
                        saldo: linha.saldo,
                        saldoPagtoFinanciamentoSugeridoAVista: linha.saldoPagtoFinanciamentoSugeridoAVista,
                        saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal:
                            linha.saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal,
                    })

                    financiamentoSugeridoTotalGeral += financiamentoSugeridoTotal
                    financiamentoAlternativoTotalGeral += financiamentoAlternativoTotal
                    financiamentoSugeridoValorAluguelAposContemplacaoTotalGeral += financiamentoSugeridoValorAluguelAposContemplacaoTotal
                    financiamentoSugeridoSaldoAluguelAposContemplacaoTotalGeral +=
                        financiamentoSugeridoSaldoAluguelAposContemplacaoTotal
                    valorTotalGeral += valorTotal

                    id = ''
                    financiamentoSugeridoTotal = 0
                    financiamentoAlternativoTotal = 0
                    financiamentoSugeridoValorAluguelAposContemplacaoTotal = 0
                    financiamentoSugeridoSaldoAluguelAposContemplacaoTotal = 0
                    valorTotal = 0
                }
            })

            fluxoCaixaMensalEconomiaPerdaResumo.push({
                parcelas: '',
                id: '',
                financiamentoSugerido: '',
                financiamentoAlternativo: '',
                financiamentoSugeridoValorAluguelAposContemplacao: '',
                financiamentoSugeridoSaldoAluguelAposContemplacao: '',
                financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao: '',
                financiamentoSugeridoValorImovelAposContemplacao: '',
                financiamentoSugeridoResultadoAluguelAposContemplacao: '',
                financiamentoSugeridoSaldoVendaAposQuitacao: '',
                financiamentoSugeridoResultadoAluguelAposQuitacao: '',
                valor: '',
                saldo: '',
                saldoPagtoFinanciamentoSugeridoAVista: '',
                saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal: '',
            })

            fluxoCaixaMensalEconomiaPerdaResumo.push({
                parcelas: '',
                id: LABEL.total,
                financiamentoSugerido: financiamentoSugeridoTotalGeral,
                financiamentoAlternativo: financiamentoAlternativoTotalGeral,
                financiamentoSugeridoValorAluguelAposContemplacao: financiamentoSugeridoValorAluguelAposContemplacaoTotalGeral,
                financiamentoSugeridoSaldoAluguelAposContemplacao:
                    financiamentoSugeridoSaldoAluguelAposContemplacaoTotalGeral,
                financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao,
                financiamentoSugeridoValorImovelAposContemplacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .financiamentoSugeridoValorImovelAposContemplacao,
                financiamentoSugeridoResultadoAluguelAposContemplacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .financiamentoSugeridoResultadoAluguelAposContemplacao,
                financiamentoSugeridoSaldoVendaAposQuitacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .financiamentoSugeridoSaldoVendaAposQuitacao,
                financiamentoSugeridoResultadoAluguelAposQuitacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .financiamentoSugeridoResultadoAluguelAposQuitacao,
                valor: valorTotalGeral,
                saldo: fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1].saldo,
                saldoPagtoFinanciamentoSugeridoAVista:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .saldoPagtoFinanciamentoSugeridoAVista,
                saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 1]
                        .saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal,
                bold: true,
            })
            
            fluxoCaixaMensalEconomiaPerdaDetalhe.push({
                parcelas: LABEL.total,
                id: '',
                financiamentoSugerido: '',
                financiamentoAlternativo: '',
                financiamentoSugeridoValorAluguelAposContemplacao: '',
                financiamentoSugeridoSaldoAluguelAposContemplacao: '',
                financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao: '',
                financiamentoSugeridoValorImovelAposContemplacao: '',
                financiamentoSugeridoResultadoAluguelAposContemplacao: '',
                financiamentoSugeridoSaldoVendaAposQuitacao: '',
                financiamentoSugeridoResultadoAluguelAposQuitacao: '',
                valor: '',
                saldo: '',
                saldoPagtoFinanciamentoSugeridoAVista: '',
                saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal: '',
            })

            fluxoCaixaMensalEconomiaPerdaDetalhe.push({
                parcelas: LABEL.total,
                id: LABEL.total,
                financiamentoSugerido: financiamentoSugeridoTotalGeral,
                financiamentoAlternativo: financiamentoAlternativoTotalGeral,
                financiamentoSugeridoValorAluguelAposContemplacao: financiamentoSugeridoValorAluguelAposContemplacaoTotalGeral,
                financiamentoSugeridoSaldoAluguelAposContemplacao:
                    financiamentoSugeridoSaldoAluguelAposContemplacaoTotalGeral,
                financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .financiamentoSugeridoSaldoInvestimentoSaldoAluguelAposContemplacao,
                financiamentoSugeridoValorImovelAposContemplacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .financiamentoSugeridoValorImovelAposContemplacao,
                financiamentoSugeridoResultadoAluguelAposContemplacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .financiamentoSugeridoResultadoAluguelAposContemplacao,
                financiamentoSugeridoSaldoVendaAposQuitacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .financiamentoSugeridoSaldoVendaAposQuitacao,
                financiamentoSugeridoResultadoAluguelAposQuitacao:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .financiamentoSugeridoResultadoAluguelAposQuitacao,
                valor: valorTotalGeral,
                saldo: fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2].saldo,
                saldoPagtoFinanciamentoSugeridoAVista:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .saldoPagtoFinanciamentoSugeridoAVista,
                saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal:
                    fluxoCaixaMensalEconomiaPerdaDetalhe[fluxoCaixaMensalEconomiaPerdaDetalhe.length - 2]
                        .saldoPagtoParcelasFinanciamentoSugeridoReceitaMensal,
                bold: true,
            })

            if (valorPagtoFinanciamentoAVista) {
                
                fluxoCaixaMensalEconomiaPerdaResumo = [
                    {saldoPagtoFinanciamentoSugeridoAVista: valorPagtoFinanciamentoAVista},
                    ...fluxoCaixaMensalEconomiaPerdaResumo
                ]

                fluxoCaixaMensalEconomiaPerdaDetalhe = [
                    {saldoPagtoFinanciamentoSugeridoAVista: valorPagtoFinanciamentoAVista},
                    ...fluxoCaixaMensalEconomiaPerdaDetalhe
                ]
            }
            
            //let irrFinanciamentoSugerido

            //if (linhaFinanciamentoSugerido.tabelaSAC || linhaFinanciamentoSugerido.consorcio) {

            //    if (linhaFinanciamentoSugerido.tabelaSAC) {

            //        irrFinanciamentoSugerido = linhaFinanciamentoSugerido.taxaAnual

            //    } else {

            //        calculaIrr(fluxoCaixaMensalFinanciamentoSugerido, round(linhaFinanciamentoSugerido.valorSaldoDevedor, 2))
            //    }
            //}

            graficoTransformaZeroNull(graficoFinanciamentoSugerido)
            graficoTransformaZeroNull(graficoFinanciamentoAlternativo)
            graficoTransformaZeroNull(graficoFinanciamentoSugeridoValorAluguelAposContemplacao)
            graficoTransformaZeroNull(graficoFinanciamentoSugeridoValorImovelAposContemplacao)

            estudo.current.graficoFinanciamentoSugerido = graficoFinanciamentoSugerido
            estudo.current.graficoFinanciamentoAlternativo = graficoFinanciamentoAlternativo
            estudo.current.graficoFinanciamentoSugeridoValorAluguelAposContemplacao =
                graficoFinanciamentoSugeridoValorAluguelAposContemplacao
            estudo.current.graficoFinanciamentoSugeridoValorImovelAposContemplacao =
                graficoFinanciamentoSugeridoValorImovelAposContemplacao
            estudo.current.graficoEcomoniaFinanciamentoSugerido = graficoEcomoniaFinanciamentoSugerido
            estudo.current.graficoPerdaFinanciamentoSugerido = graficoPerdaFinanciamentoSugerido
            estudo.current.graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo = graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo
            estudo.current.graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo = graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo
            estudo.current.graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo =
                graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo
            estudo.current.graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo =
                graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo
            estudo.current.fluxoCaixaMensalEconomiaPerdaDetalhe = fluxoCaixaMensalEconomiaPerdaDetalhe
            estudo.current.fluxoCaixaMensalEconomiaPerdaResumo = fluxoCaixaMensalEconomiaPerdaResumo
            //estudo.current.idadesFinanciamento = idadesFinanciamento
            estudo.current.anosFinanciamento = anosFinanciamento
            estudo.current.descricaoFinanciamentoSugerido = pesquisaDescricaoList(financiamentoList(values, null, false),
                values.objComparacaoFinanciamentos.idFinanciamentoSugerido)
            estudo.current.descricaoFinanciamentoAlternativo = pesquisaDescricaoList(financiamentoList(values, null, false),
                values.objComparacaoFinanciamentos.idFinanciamentoAlternativo)
            estudo.current.descricaoAbreviadaFinanciamentoSugerido = pesquisaDescricaoList(financiamentoList(values, null, true),
                values.objComparacaoFinanciamentos.idFinanciamentoSugerido)
            estudo.current.descricaoAbreviadaFinanciamentoSugerido = pesquisaDescricaoList(financiamentoList(values, null, true),
                values.objComparacaoFinanciamentos.idFinanciamentoSugerido)
            estudo.current.descricaoAbreviadaFinanciamentoAlternativo = pesquisaDescricaoList(financiamentoList(values, null, true),
                values.objComparacaoFinanciamentos.idFinanciamentoAlternativo)
            estudo.current.descricaoFinanciamentoSugeridoValorAluguelAposContemplacao =
                descricaoFinanciamentoSugeridoValorAluguelAposContemplacao
            estudo.current.descricaoSaldoInvestimentoAluguelAposContemplacao =
                descricaoSaldoInvestimentoAluguelAposContemplacao
            estudo.current.descricaoSaldoVendaAposQuitacao = descricaoSaldoVendaAposQuitacao
            estudo.current.descricaoSaldoAluguelAposQuitacao = descricaoSaldoAluguelAposQuitacao
            estudo.current.descricaoFinanciamentoSugeridoValorizacaoImovelAluguelAposContemplacao =
                descricaoFinanciamentoSugeridoValorizacaoImovelAluguelAposContemplacao
            estudo.current.percValorizacaoImovelAluguelAposContemplacao =
                linhaFinanciamentoSugerido.percValorizacaoImovelAluguelAposContemplacao
        }
    }
}

/*
const calculaIrr = (fluxo, invest) => {

    console.log(fluxo)
    let irrMin = 0.01
    let irrMax = 5
    let irrAdd = 0.01

    let continuar = true

    let taxa = null

    let irr = irrMin

    while (continuar) {

        let total = 0

        // eslint-disable-next-line 
        fluxo?.forEach( (linha, ind) => {
            
            total = total + (linha.valor / Math.pow(1 + (irr / 100), ind + 1))
        })
        console.log('---------')
        console.log(total)
        console.log(invest)
        console.log(irr)

        total = total - invest

        if (irr > irrMax) {

            continuar = false

        } else {

            if (total < -100) {

                irr = irr - irrAdd
                
                irrAdd = 0.001

            } else {

                if (total >= -100 && total <= 100) {

                    taxa = irr
                    continuar = false

                } else {

                    irr = irr + irrAdd
                }
            }
        }
    }

    console.log(taxa)

    return taxa
}
*/